export type StatusColorType =
  | 'gray'
  | 'gray-darker'
  | 'blue-lightest'
  | 'blue-light'
  | 'blue'
  | 'green-lightest'
  | 'green'
  | 'slate'
  | 'red'
  | 'yellow'
  | 'orange'
  | 'purple'
  | 'pink'
  | 'white';

export const STATUS_COLORS: StatusColorType[] = [
  'gray',
  'gray-darker',
  'blue-lightest',
  'blue-light',
  'blue',
  'green-lightest',
  'green',
  'slate',
  'red',
  'yellow',
  'orange',
  'purple',
  'pink',
  'white',
];
